import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MicrosoftSharedVoicemailGroupMembership } from '../models/generated/ziroModels';

@Injectable()
export class MicrosoftSharedVoicemailGroupsContext {
  private _http = inject(HttpClient);
  private _stateSource = new ReplaySubject<MicrosoftSharedVoicemailGroupMembership>(1);
  state$ = this._stateSource.asObservable();

  get(tenantId: string, userPrincipalName: string): Observable<MicrosoftSharedVoicemailGroupMembership> {
    return this._http
      .get<MicrosoftSharedVoicemailGroupMembership>(
        `/services/microsoft/macs/tenants/${tenantId}/shared-voicemail-groups/${userPrincipalName}`,
      )
      .pipe(
        tap((groupMembership: MicrosoftSharedVoicemailGroupMembership) => {
          this._stateSource.next(groupMembership);
        }),
      );
  }

  updateUserGroups(
    tenantId: string,
    userPrincipalName: string,
    sharedVoicemailGroupMembership: MicrosoftSharedVoicemailGroupMembership,
  ): Observable<void> {
    return this._http
      .put<void>(
        `/services/microsoft/macs/tenants/${tenantId}/shared-voicemail-groups/${userPrincipalName}`,
        sharedVoicemailGroupMembership,
      )
      .pipe(
        tap(() => {
          this._stateSource.next(sharedVoicemailGroupMembership);
        }),
      );
  }
}
